import { apiTransformer } from 'utils';

export const profileToApiTransformer = (values, originalProfile = null)=> {
    return {
        ...(originalProfile ? {id: '/api/profiles/' + originalProfile.id } : {}),
        ...apiTransformer(values, ['club', 'location']),
    };
}
